import type { ClientPortfolioManualValueResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import type { ManualValueFormInput } from "web_myplann/Portfolio/PortfolioShared/ManualValue/manualValueFormTypes";

export const mapManualValueToForm = (
	manualValue: ClientPortfolioManualValueResponseDTO | undefined,
): ManualValueFormInput => ({
	value: manualValue?.value ?? null,
	invested: manualValue?.invested ?? null,
	valueDate: parseIsoDate(manualValue?.date),
});
